import { getCurrentFinancialDeckEntity } from "@/models/financialDecks";
import { authStateAtom } from "@/orm/auth";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import { useAsyncCallback } from "react-async-hook";
import { useIsPlanInactive } from "./useIsPlanInactive";

export const useIsUserModelCreator = () => {
  const financialDeckEntity = getCurrentFinancialDeckEntity();

  const {
    loading,
    execute: hydrate,
    result: model,
    error,
  } = useAsyncCallback(financialDeckEntity.hydrate);

  useEffect(() => {
    hydrate();
  }, []);

  const { user } = useAtomValue(authStateAtom);

  return [model?.creatorId === user?.uid, loading, error] as const;
};

export const useIsModelReadOnly = () => {
  const [isUserModelCreator] = useIsUserModelCreator();
  const { isPlanInactive } = useIsPlanInactive();
  const setIsModelReadOnlyFromHookAtom = useSetAtom(
    isModelReadOnlyFromHookAtom,
  );

  const result = !isUserModelCreator || isPlanInactive;

  setIsModelReadOnlyFromHookAtom(result);

  return [result] as const;
};

export const isModelReadOnlyFromHookAtom = atom(false);
